import { DaftarRaporMurid as TDaftarRaporMurid } from "../../../templates/Rapor/DaftarRaporMurid";

const DaftarRaporMurid = () => {
  return <TDaftarRaporMurid />;
};

export default DaftarRaporMurid;
